import { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ScreenOverlay, Spinner } from "../../components/Common";
import QuoteFormStep1 from "./components/step-one-form";
import useAuthUser from "../../common/hooks/authUser";
import { useJob, useJobCreate, useJobUpdate } from "../../common/hooks/api/job";
import { toastError, toastSuccess } from "../../helpers/toast-helper";
import { getResponseItemData } from "../../helpers/response-helper";

const JobCreatePage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { search } = useLocation();
    const { user } = useAuthUser();
    const [isDisabled, setIsDisabled] = useState(false);

    const { data: jobResponse, isLoading } = useJob(id, {
        enabled: !!id,
        onError: () => {
            toastError("Cannot fetch the job");
        }
    });

    const { data: job } = getResponseItemData(jobResponse);
    const { mutate: createJob, isPending: isCreating } = useJobCreate();
    const { mutate: updateJob, isPending: isSaving } = useJobUpdate();

    const onCancel = () => {
      navigate('/jobs');
    };

    const query = new URLSearchParams(search);
    const quoteId = +query.get('quoteId')!;

    const onSaveStep1 = ({ data }) => {
        const payload = {
            ...data,
            id,
            quoteId: id ? data?.quoteId : quoteId,
            userId: user.id,
            jobStatusId: job?.jobStatusId || 1, // FK still required; status is now computed from dates
        };

        if (id) {
            updateJob(payload, {
                onSuccess: async () => {
                    setIsDisabled(true);
                    await toastSuccess("Job was successfully updated");
                    navigate(`/jobs`);
                },
                onError: () => {
                    toastError("Cannot update the job");
                },
            });
        } else {
            createJob(payload, {
                onSuccess: async () => {
                    setIsDisabled(true);
                    await toastSuccess("Job was successfully created");
                    navigate(`/jobs`);
                },
                onError: () => {
                    toastError("Cannot create the Job");
                },
            });
        }
    };

    return (
        <>
            <QuoteFormStep1
                data={job}
                isEditMode={!!id}
                isSaving={isCreating || isSaving || isDisabled}
                onCancel={onCancel}
                onSave={onSaveStep1}
            />
            {isLoading && (
                <>
                    <ScreenOverlay />
                    <Spinner />
                </>
            )}
        </>
    );
};

export default JobCreatePage;
